import workspaceQuery from '../../../graphql/queries/product/AssemblyNoteTypeWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/AssemblyNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/AssemblyNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/AssemblyNoteTypeMutation.graphql';
import listQuery from '../../../graphql/queries/product/AssemblyNoteTypeListQuery.graphql';
import fragment from '../../../graphql/fragments/product/AssemblyNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const AssemblyNoteType: EntityType = {
  type: 'AssemblyNoteType',
  title: 'Assembly Note Types',
  formTitle: 'Assembly Note Type',
  formUrl: '/Products/Assembly/NoteType/Details/',
  workspaceUrl: '/Products/Assembly/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'ASSEMBLY_NOTE_TYPES',
};

export default AssemblyNoteType;
